// extracted by mini-css-extract-plugin
export default {"closeIcon":"ButtonCloseModal_closeIcon__nTwDE","closeIconR40":"ButtonCloseModal_closeIconR40__SpexN","closeIconWhite":"ButtonCloseModal_closeIconWhite__oIzTR"};